import React, { useContext, useState } from 'react'
import { useEffect } from 'react';
import UtilsBufer from '../Tools/UtilsBufer';
import { ContextoAdminProtocolo } from './PrincipalAdminProtocolo';
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ItemProtocolo(props) {
    const { info, index } = props
    const { setModalShow, setTituloModal, setInfo, setVentana, regional, setLoader, setTipoModal, setModalCambio, setModalAlerta } = useContext(ContextoAdminProtocolo);
    const [protocolo, setProtocolo] = useState(info);
    const [version, setVersion] = useState(info.ID_VERSION_ACTIVA);
    const [hayDato, setHayDato] = useState(false);
    const getColor = (valor) => {
        if (valor !== null && valor !== undefined) {
            if (valor.indexOf('A') >= 0) {
                return 'bg-success bg-gradient'
            } else if (valor.indexOf('R') >= 0) {
                return 'bg-danger bg-gradient'
            } else if (valor.indexOf('C') >= 0) {
                return 'bg-secondary bg-gradient'
            } else if (valor.indexOf('P') >= 0) {
                return 'bg-warning bg-gradient'
            }
        } else {
            return ''
        }
    }
    const cambiarVersion = (valor) => {
        setLoader(true);
        var dato = protocolo.VERSIONES.filter((item) => item.ID_VERSION == valor)[0]
        let aux = protocolo
        setVersion(dato.ID_VERSION);
        aux.ID_VERSION_ACTIVA = dato.ID_VERSION;
        aux.VERSION_ACTIVA = dato.VERSION;
        aux.ESTADO = dato.ESTADO;
        fetch(`${server}/protocolos/getProtocolos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, idVersion: aux.ID_VERSION_ACTIVA, idProtocolo: aux.ID_PROTOCOLO, idArea: aux.ID_AREA
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data.ok);
                if (data.ok) {
                    aux.MENU = data.ok[0].MENU;
                    setProtocolo(aux);
                } else {
                    MsgUtils.msgError(data.error)
                }
                setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    const editarProtocolo = () => {
        setTipoModal('A');
        setInfo(protocolo);
        setTituloModal("Editando Protocolo " + protocolo.ID_PROTOCOLO);
        setModalShow(true);
    }
    function alertProtocoloEstado(estado) {
        if (estado === 'P') {
            return <span className='text-warning'>PENDIENTE</span>
        } else if (estado === 'A') {
            return <span className='text-success'>APROBADO</span>
        } else if (estado === 'R') {
            return <span className='text-danger'>RECHAZADO</span>
        }
    }
    const agregarContenido = () => {
        setInfo(protocolo);
        setVentana(1);
    }
    const vistaPreviaProtocolo = () => {
        var infoP = protocolo;
        infoP.ESTADO = 'A';
        setInfo(infoP);
        setVentana(1)
    }
    function cambiarEstadoProtocolo() {
        setInfo(protocolo);
        setTituloModal("Cambiar Estado " + protocolo.DESCRIPCION + " versión " + protocolo.VERSION_ACTIVA);
        setModalCambio(true);
    }
    function addNewVersion() {
        setTipoModal('B');
        setInfo(protocolo);
        setTituloModal("Creando Nueva Version del Protocolo " + protocolo.ID_PROTOCOLO);
        setModalShow(true);
    }
    function eliminarProtocolo() {
        setInfo(protocolo);
        setTituloModal('Esta seguro de eliminar la version ' + protocolo.VERSION_ACTIVA + ' del PROTOCOLO ' + protocolo.DESCRIPCION);
        setModalAlerta(true);
    }
    useEffect(() => {
        console.log(info);
        setProtocolo(info);
        setHayDato(true);
    }, [info])
    /*useEffect(() => {
        console.log(info);
        setHayDato(true)
    }, [])*/
    return (
        <tr className={getColor(protocolo.ESTADO)}>
            {protocolo.VERSIONES !== undefined && hayDato && <th scope="row" className="col-1">
                <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                    {UtilsBufer.getFotoCard((protocolo.VERSIONES).filter((dd) => dd.ID_VERSION === protocolo.ID_VERSION_ACTIVA)[0].FOTO, 40)}
                    <div className='ps-2 my-auto d-none d-sm-inline'>
                        <div className="cargoHeader fw-bold">{(protocolo.VERSIONES).filter((dd) => dd.ID_VERSION === protocolo.ID_VERSION_ACTIVA)[0].NOMBREX}</div>
                        <div className='cargoHeader '>{(protocolo.VERSIONES).filter((dd) => dd.ID_VERSION === protocolo.ID_VERSION_ACTIVA)[0].CARGO}</div>
                    </div>
                </div>
            </th>}
            {hayDato && <td className='col-2'>
                <div className='container-fluid m-2 p-0 text-center'>
                    {protocolo.DESCRIPCION}
                </div>
                {/*
                <div className='container-fluid fw-bold m-0 p-0'>
                    {'Categoria: ' + (protocolo.CATEGORIA == null ? '?' : protocolo.CATEGORIA)}
                </div>*/}
                <div className='alert alert-sm alert-light fw-bold text-center m-0 p-0'>
                    {alertProtocoloEstado(protocolo.ESTADO)}
                </div>
            </td>}
            {hayDato && protocolo.VERSIONES !== undefined && <td className='col-1'>
                <div className='text-center'>
                    <div>
                        <select className="form-select form-select-sm " value={version} onChange={(e) => cambiarVersion(e.target.value)}>
                            {protocolo.VERSIONES.map((dato, id) => {
                                return (
                                    <option value={dato.ID_VERSION} key={id}>Ver.{dato.VERSION}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className='py-1'>
                        <button className='btn btn-sm btn-secondary w-100'
                            onClick={() => addNewVersion()}
                        ><i className="fa-solid fa-circle-plus fa-xl"></i> Nuevo</button>
                    </div>
                </div>
            </td>}
            {hayDato && <td className='col' style={{minWidth:'120px',maxWidth:'120px'}}>
                <div className='fw-bold'>
                    {protocolo.AREA.split(':').map((item,index) => {
                        return (
                            <div className='badge bg-light text-dark w-100' key={index}>
                                {item}
                            </div>
                        )
                    })}

                </div>
            </td>}
            {hayDato && <td className='col-9 text-end my-auto'>
                <div className='btn-group btn-group-sm'>
                    <button className='btn btn-sm btn-light colorAzul' title='Vista previa Protocolo'
                        onClick={() => vistaPreviaProtocolo()}>
                        <i className="fa-solid fa-eye fa-xl"></i>
                    </button>
                    <button className='btn btn-sm btn-light text-danger' title='Eliminar Protocolo'
                        onClick={() => eliminarProtocolo()}>
                        <i className="fa-solid fa-trash fa-xl"></i>
                    </button>
                    <button className='btn btn-sm btn-light text-warning' title='Editar Protocolo'
                        onClick={() => editarProtocolo()}>
                        <i className="fa-solid fa-pen-to-square fa-xl"></i>
                    </button>
                    <button className='btn btn-sm btn-light text-success' title='Agregar Contenido'
                        onClick={() => agregarContenido()}>
                        <i className="fa-solid fa-notes-medical fa-xl"></i>
                    </button>
                </div>
                <div className='m-0 p-0 py-1'>
                    <button className='btn btn-dark btn-sm '
                        onClick={() => cambiarEstadoProtocolo()}
                    ><i className="fa-solid fa-hourglass-start fa-xl"></i> Cambiar Estado</button>
                </div>
            </td>}
        </tr>
    )
}

export default ItemProtocolo
